import { useEffect, useState } from 'react';
import { PropsWithChildren } from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Typography, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { getTrialDaysRemaining } from 'util/date-util';

const t = (key: string, options?) => translate('home', key, options);

type Props = PropsWithChildren<{
  name: string;
  trialLicense: any;
}>;

const GreetingHeader: React.FC<Props> = ({ name = '', trialLicense = {} }) => {
  const classes = useStyles();
  const [daysRemaining, setDaysRemaining] = useState(0);

  useEffect(() => {
    if (trialLicense) {
      const noDaysRemaining = getTrialDaysRemaining(trialLicense.dateExpiration);
      setDaysRemaining(noDaysRemaining);
    }
  }, [trialLicense]);
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} md={6}>
        <Typography variant="h1" className={classes.gridItem}>
          <span className={classes.h1}>{t('hi')}, </span>
          {name}
        </Typography>
        <Typography variant="h2" className={`${classes.h2} ${classes.gridItem}`}>
          {t('welcomeToAtoZ')}
        </Typography>
      </Grid>
      {trialLicense && (
        <Grid item xs={12} md={6} className={`${classes.daysLeft}`}>
          <Typography variant="h2">
            <span className={classes.daysLeftNumber}>{daysRemaining}</span>
            <span className={classes.daysLeftText}>{t('daysLeft')}</span>
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

const useStyles = makeStyles((theme: any) => ({
  gridItem: {
    marginLeft: theme.spacing(4),
  },
  h1: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 300,
  },
  h2: {
    fontSize: theme.typography.h3.fontSize,
    fontWeight: 'bold',
    marginTop: '-20px',
    ['@media (max-width:770px)']: {
      marginTop: '0px',
    },
  },
  root: {
    flexGrow: 1,
    marginTop: '30px',
  },
  daysLeft: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      padding: '30px 0',
    },
  },
  daysLeftNumber: {
    backgroundColor: '#FFF',
    border: '4px solid black',
    '-webkit-border-radius': '50%',
    '-moz-border-radius': '50%',
    borderRadius: '50%',
    fontSize: '24px',
    padding: '12px 18px',
    fontWeight: 'bolder',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      marginLeft: '10px',
    },
  },
  daysLeftText: {
    fontSize: '24px',
    margin: '15px 15px -3px 15px',
    textDecoration: 'underline',
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
    },
  },
}));

export default GreetingHeader;
